import { PaymentInformationConstants } from './paymentInformation.constants'
import { IPaymentInformationAction, IPaymentInformationState } from './paymentInformation.types'

export const initialPaymentInformationState: IPaymentInformationState = {
  primaryMethodOfPayment: null,
  primaryMethodOfPaymentPNNV: null,
  x12PayerType: null,
  priorAuthorizationPayer: null,
}

export function paymentInformationReducer(
  state: IPaymentInformationState = initialPaymentInformationState,
  action: IPaymentInformationAction
): IPaymentInformationState {
  switch (action.type) {
    case PaymentInformationConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case PaymentInformationConstants.SET_PRIMARY_METHOD_OF_PAYMENT:
      return { ...state, primaryMethodOfPayment: action.primaryMethodOfPayment }
    case PaymentInformationConstants.SET_PRIMARY_METHOD_OF_PAYMENT_PNNV:
      return { ...state, primaryMethodOfPaymentPNNV: action.primaryMethodOfPaymentPNNV }
    case PaymentInformationConstants.SET_X12_PAYER_TYPE:
      return { ...state, x12PayerType: action.x12PayerType }
    case PaymentInformationConstants.SET_PRIOR_AUTHORIZATION_PAYER:
      return { ...state, priorAuthorizationPayer: action.priorAuthorizationPayer }
    case PaymentInformationConstants.SET_PAYMENT_INFORMATION:
      return { ...action.paymentInformation }
    case PaymentInformationConstants.RESET_PAYMENT_INFORMATION:
      return { ...initialPaymentInformationState }
    default:
      return state
  }
}
